import { Link } from "react-router";

import { Card } from "@mui/material";

import { Contained, StyledButton } from "@components/StyledComponents";
import { useAuthUser } from "@features/auth";
import { realmPathUrl } from "@features/navigation/helpers";
import DocTitle from "@utils/DocTitle";

const FourOhFour = () => {
  const { realm } = useAuthUser();
  const backLink = realmPathUrl(realm, "/");
  return (
    <>
      <DocTitle title={"Not Found"} />
      <Contained>
        <Card className="my-6 px-6 py-10">
          <h1 className="text-6xl text-neutral-300 font-bold">404</h1>
          <h2 className="text-4xl text-neutral-600 font-bold">Not found</h2>
          <p className="text-lg max-w-prose mt-2 mb-6">
            Either this page doesn't exist, or you don't have the right
            permissions to access it. If you think this is a mistake, please
            contact your account administrator.
          </p>
          <StyledButton cta component={Link} to={backLink}>
            Take me back
          </StyledButton>
        </Card>
      </Contained>
    </>
  );
};

export default FourOhFour;
